class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/add`;
    }
    /**
     * Adds members to the specified team.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/teams/{chatId}/add
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async post(tMAddTeamMembersRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMAddTeamMembersRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
